/*eslint-disable react/no-set-state */
import React from 'react'
import PropTypes from 'prop-types'

import { SelectField, MenuItem } from 'material-ui'
import { grey900 as HintColor } from 'material-ui/styles/colors'
import { Date2 } from '../date'
import { AuditUser } from '../audit'

import { createStyleSheet } from 'jss-theme-reactor'
const styleSheet = createStyleSheet('ReadmissionRisk', theme => {
  return {
    updatedBy: {
      textAlign: 'right',
    },
  }
})

export const ReadmissionRisk = (
  {
    visit,
    onReadmissionRiskChange,
    readmissionRisk,
    readmissionRiskVerifiedBy,
    readmissionRiskUpdatedWhen,
  },
  context
) => {
  const classes = context.styleManager.render(styleSheet)

  const items = [
    <MenuItem key={false} value={false} primaryText="No" />,
    <MenuItem key={true} value={true} value primaryText="Yes" />,
  ]

  const riskEdited = !(readmissionRisk === null)
  const marginTop = readmissionRisk === null ? '-14px' : '-14px'

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-xs-6" style={{ marginTop: marginTop }}>
          <SelectField
            value={readmissionRisk}
            onChange={(event, index, value) =>
              value !== visit.readmissionRisk &&
              onReadmissionRiskChange(visit.id, value)
            }
            hintText="Not Set"
            hintStyle={{ color: HintColor }}>
            {items}
          </SelectField>
        </div>
        {riskEdited && (
          <div className="col-xs-6">
            <div className={classes.updatedBy}>
              Updated: <Date2 dateString={readmissionRiskUpdatedWhen} /> By:{' '}
              <AuditUser user={readmissionRiskVerifiedBy} emptyText="System" />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

ReadmissionRisk.contextTypes = {
  styleManager: PropTypes.object.isRequired,
}

ReadmissionRisk.propTypes = {
  visit: PropTypes.object.isRequired,
  onReadmissionRiskChange: PropTypes.func.isRequired,
  readmissionRisk: PropTypes.bool,
  readmissionRiskVerifiedBy: PropTypes.shape({
    userName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
  readmissionRiskUpdatedWhen: PropTypes.string,
  readmissionRiskVerifiedBySystemWhen: PropTypes.string,
}
